export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "exam_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select exam type"])},
        "sitting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select location & date"])},
        "accommodation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select accommodations"])},
        "payment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payment"])},
        "review": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Review"])},
        "confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation"])}
      },
      "fr": {
        "payment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paiement"])},
        "exam_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner le type d’examen"])},
        "accommodation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner une mesure d'accommodement"])},
        "sitting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner le lieu et la date"])},
        "review": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérification"])},
        "confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation"])}
      }
    }
  })
}